const RemoveItemsDuplicates = ({ items, key }) =>
  items.filter((obj, index) => {
    return items.map(obj => obj[key]).indexOf(obj[key]) === index;
  });

export default RemoveItemsDuplicates;
